<template>
  <transition name="el-fade-in">
    <div class="modal-bg" v-show="show">
      <div class="modal-container" :style="getStyle">
        <div class="modal-header"></div>
        <div class="modal-main">
          <slot name="content"></slot>
        </div>
        <div class="modal-footer" v-if="$slots.footer">
          <slot name="footer"></slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "modal",
  props: {
    /** 弹框宽度 */
    width: {
      type: String,
      default: "24.1vw",
    },
    /** 显示弹框 */
    show: {
      type: Boolean,
      default: false,
    },
    /** 标题 */
    title: {
      type: String,
      default: "详情",
    },
    /** 显示关闭按钮 */
    showColse: {
      type: Boolean,
      default: true,
    },
    /** 样式 */
    setStyle: {
      type: [Object, Array],
      default() {
        return {};
      },
    },
    // 合作社类型
    cooperativeTypes: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  computed: {
    getStyle() {
      return {
        width: this.width,
        ...this.setStyle,
      };
    },
  },
  methods: {
    close() {
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@assets/css/var.scss";
.modal-bg {
  position: relative;
  transition: display 2000ms;
  /* position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: rgba(0, 0, 0, .5);
		z-index: 10; */
}

.modal-del {
  position: absolute;
  right: vh(19);
  height: vw(10);
}
.close {
  width: vw(20);
  height: vh(20);
  cursor: pointer;
}
.modal_efect {
  padding: vw(20) vh(80);
  width: vw(466);
}

.modal-container {
  overflow: hidden;
  position: fixed;
  top: 50%;
  left: 50%;
  z-index: 100;
  transform: translate(-50%, -100%);
}

.modal-header {
  height: 10px;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-image: url("../assets/images/socializationIcon/map-icon/bg_con_line.png");
  background-size: 100% 100%;
}

.modal-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  height: vh(57);
  background: rgba(10, 77, 19, 0.8);
}

.modal-footer button {
  width: vw(100);
}

.modal-main {
  //padding: 15px 40px;
  background: linear-gradient(
    0deg,
    rgba(3, 49, 19, 0.87),
    rgba(5, 51, 21, 0.7)
  );
  border: 2px solid;
  border-image: linear-gradient(0deg, #00ff6f, #00ba51) 10 10;
  margin-top: vh(-1);
  max-height: vh(800);
  /* 谷歌美化滚动条 */
  &::-webkit-scrollbar {
    width: 6px;
    height: 6px;
    background: #ffffff;
  }
  &::-webkit-scrollbar-track {
    background: #ffffff;
    border-radius: 2px;
  }
  &::-webkit-scrollbar-thumb {
    background: rgba(48, 234, 168, 0.6);
    border-radius: 10px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: rgba(48, 234, 168, 0.8);
  }
  &::-webkit-scrollbar-corner {
    background: rgba(48, 234, 168, 0.6);
  }
  /* 火狐美化滚动条 */
  .el-dialog__body {
    scrollbar-color: rgba(48, 234, 168, 0.6) rgba(10, 77, 19, 0.2);
    /* 滑块颜色  滚动条背景颜色 */
    scrollbar-width: thin;
    /* 滚动条宽度有三种：thin、auto、none */
  }
}
</style>
